export const PRODUCTION_VERSION = "1-0";
export const CLOUD_PATH = "https://d2p078bqz5urf7.cloudfront.net/";
